/**
 * Development logger utility — only logs to console in development mode.
 * In production, console output is suppressed entirely.
 */

const isDev = import.meta.env.DEV;

export const logger = {
    /**
     * Log informational messages (only in development)
     */
    log(...args: unknown[]): void {
        if (isDev) {
            console.log(...args);
        }
    },

    /**
     * Log warning messages (only in development)
     */
    warn(...args: unknown[]): void {
        if (isDev) {
            console.warn(...args);
        }
    },

    /**
     * Log error messages.
     * Always emitted to console.error so the browser dev-tools surface them
     * even in production builds, but no remote-sink integration.
     */
    error(message: string, ...args: unknown[]): void {
        console.error(message, ...args);
    },

    /**
     * Debug logging (only in development)
     */
    debug(...args: unknown[]): void {
        if (isDev) {
            console.debug(...args);
        }
    },

    /**
     * Group logging (only in development)
     */
    group(label: string, callback: () => void): void {
        if (isDev) {
            console.group(label);
            callback();
            console.groupEnd();
        }
    },
};
